import {useSelector} from "react-redux";

import {cartItems, cartItemsLengthSelector, isCartEmptySelector, subTotalSelector} from "../../redux/draftShoppingCart.slice";

/**
 *
 * @returns {{draftShoppingCartSubTotal: number, cartItemCount: number, isCartEmpty: boolean, draftShoppingCartItems: array}}
 */
function useDraftShoppingCart() {
    const cart = useSelector(cartItems)
    const draftShoppingCartSubTotal = useSelector(subTotalSelector)
    const isCartEmpty = useSelector(isCartEmptySelector)
    const cartItemCount = useSelector(cartItemsLengthSelector)

    return {draftShoppingCartItems: cart, draftShoppingCartSubTotal, isCartEmpty, cartItemCount};
}

export default useDraftShoppingCart